import {useCallback, useEffect, useRef} from 'react'
import {useConfirm} from '@primer/react'
import {queueConfirmDialog} from '@github-ui/copilot-shared-ui/utils/confirm-dialog-queue'
import type {PullRequestConfirmation} from '../ahp/create-pull-request-tool'

export function useConfirmPullRequest(): (details: PullRequestConfirmation) => Promise<boolean> {
  const confirm = useConfirm()
  const confirmRef = useRef(confirm)
  useEffect(() => {
    confirmRef.current = confirm
  }, [confirm])
  return useCallback(
    (details: PullRequestConfirmation) =>
      // Shared with other confirm-dialog callers (e.g. `create_session`) so two
      // concurrent tool fulfilments never stack Primer's per-call modal roots.
      queueConfirmDialog(() =>
        confirmRef.current({
          title: 'Create a draft pull request?',
          content: `Repository: ${details.repoNwo}\nHead: ${details.head}\nBase: ${details.base}\nTitle: ${details.title}\n\nDescription:\n${details.body}`,
          confirmButtonContent: 'Create draft pull request',
        }),
      ),
    [],
  )
}
